module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-8-min.03927bbc.jpg";